<h3>{{ "onboarding.referred.referred" | translate: {Default:"Referidos"} }}</h3>
<p class="small">{{ "onboarding.referred.referred-agreement" | translate: {Default:"El cliente reconoce que al recomendar a un amigo a través de este programa, el cliente está divulgando información no pública."} }}</p>

<div *ngIf="!hasReferralValue">
  <form class="row" #formHasAccount="ngForm" (ngSubmit)="formHasAccount.form.valid" novalidate>
    <div class="col-12 mb-3">
      <button class="btn btn-outline-success" (click)="hasReferralValue = true"><i class="fas fa-user-plus"></i><span>{{ "onboarding.referred.addReferral" | translate: {Default:"Agregar referido"} }}</span></button>
    </div>
  </form>
</div>

<div *ngIf="hasReferralValue">
  <form class="row" #formNewAccount="ngForm" (ngSubmit)="formNewAccount.form.valid" novalidate>
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.name" | translate: {Default:"Nombre"} }}</label><small class="text-danger required">{{ "onboarding.referred.required_field" | translate: {Default:" * Campo requerido"} }}</small>
        <input type="text" class="form-control" name="firstName" [(ngModel)]="referred.firstName" #firstName="ngModel" [ngClass]="inputFieldCss(firstName, formNewAccount)" app-onlyText required>
        <app-field-error-display [control]="firstName" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.additionalNames" | translate: {Default:"Nombres Adicionales"} }}</label>
        <input type="text" class="form-control" name="additionalNames" [(ngModel)]="referred.additionalNames" #additionalNames="ngModel" [ngClass]="inputFieldCss(additionalNames, formNewAccount)" app-onlyText>
        <app-field-error-display [control]="additionalNames" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.lastName" | translate: {Default:"Apellido paterno"} }}</label><small class="text-danger required">{{ "onboarding.referred.required_field" | translate: {Default:" * Campo requerido"} }}</small>
        <input type="text" class="form-control" name="lastName" [(ngModel)]="referred.lastName" #lastName="ngModel" [ngClass]="inputFieldCss(lastName, formNewAccount)" required app-onlyText>
        <app-field-error-display [control]="lastName" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.maidenName" | translate: {Default:"Apellido materno"} }}</label>
        <input type="text" class="form-control" name="secondLastName" [(ngModel)]="referred.secondLastName" #secondLastName="ngModel" [ngClass]="inputFieldCss(secondLastName, formNewAccount)" app-onlyText>
        <app-field-error-display [control]="secondLastName" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.birthday" | translate: {Default:"Fecha de nacimiento"} }}</label>
        <div class="input-group">
          <input type="text" class="form-control" name="dateOfBirth" #d="ngbDatepicker" (dateSelect)="onReferredBirthdateChange()" [(ngModel)]="uglyReferredBirthdate" #dateOfBirth="ngModel" [ngClass]="inputFieldCss(dateOfBirth, formNewAccount)" ngbDatepicker isReferredAdult readonly aria-describedby="dateHelp">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"><i class="fas fa-calendar-alt"></i></button>
          </div>
        </div>
        <small id="dateHelp" class="form-text small text-muted">{{ "onboarding.referred.dateHelp" | translate: {Default:"Selecciona primero el año, después el mes y al final el día"} }}</small>
        <app-field-error-display [control]="dateOfBirth" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.countryWhereYouLive" | translate: {Default:"País donde vive"} }}</label>
        <small class="text-danger required">{{ "onboarding.referred.required_field" | translate: {Default:" * Campo requerido"} }}</small>
        <select class="form-control custom-select" name="birthplace" [(ngModel)]="referred.country" #birthplace="ngModel" [ngClass]="inputFieldCss(birthplace, formNewAccount)" required>
          <option [ngValue]="null">{{ "onboarding.referred.select" | translate: {Default:"Selecciona..."} }}</option>
          <option *ngFor="let country of countryWhereYouLive" [ngValue]="country.value">{{country.value}}</option>
        </select>
        <app-field-error-display [control]="birthplace" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.relationship" | translate: {Default:"Parentesco"} }}</label>
        <small class="text-danger required">{{ "onboarding.referred.required_field" | translate: {Default:" * Campo requerido"} }}</small>
        <select class="form-control custom-select" name="relationship" [(ngModel)]="referred.referrerIdRelationship" #relationship="ngModel" [ngClass]="inputFieldCss(relationship, formNewAccount)" required>
          <option [ngValue]="null">{{ "onboarding.referred.select" | translate: {Default:"Selecciona..."} }}</option>
          <option *ngFor="let relation of referredRelationship" [ngValue]="relation.id">{{relation.value}}</option>
        </select>
        <app-field-error-display [control]="relationship" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div *ngIf="referred.referrerIdRelationship == 6" class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.relationshipOther" | translate: {Default:"Parentesco (especifíque)"} }}</label>
        <small class="text-danger required">{{ "onboarding.referred.required_field" | translate: {Default:" * Campo requerido"} }}</small>
        <input class="form-control" name="otherRelationship" [(ngModel)]="referred.referrerRelationship" #otherRelationship="ngModel" [ngClass]="inputFieldCss(otherRelationship, formNewAccount)" required>
        <app-field-error-display [control]="otherRelationship" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.phone" | translate: {Default:"No. Celular"} }}</label>
        <small class="text-danger required">{{ "onboarding.referred.cellphoneRequired" | translate: {Default:" * Campo requerido (o correo electrónico)"} }}</small>
        <input type="tel" [mask]="getCountryPhoneData(ePhoneCountries.USA, this.configurationService.application).mask" class="form-control" name="phoneNumber" [(ngModel)]="referred.phoneNumber" #phoneNumber="ngModel" [ngClass]="inputFieldCss(phoneNumber, formNewAccount)" numbers [required]="!email.value || email.value === ''">
        <app-field-error-display [control]="phoneNumber" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.referred.email" | translate: {Default:"Correo electrónico"} }}</label><small class="text-danger required" >{{ "onboarding.referred.emailRequired" | translate: {Default:" * Campo requerido (o celular)"} }}</small>
        <input type="email" class="form-control" name="email" [(ngModel)]="referred.email" #email="ngModel" [ngClass]="inputFieldCss(email, formNewAccount)" email [required]="!phoneNumber.value || phoneNumber.value === ''" app-email>
        <app-field-error-display [control]="email" [form]="formNewAccount"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 mb-3">
      <button class="btn btn-secondary float-left" type="button" (click)="cancel(formNewAccount)">{{ "onboarding.referred.cancel" | translate: {Default:"Cancelar"} }}</button>
      <button class="btn btn-primary float-right" (click)="onSubmit_newAccount(formNewAccount)" [disabled]="!formNewAccount.form.valid">{{ "onboarding.referred.continue" | translate: {Default:"Continuar"} }}</button>
    </div>
  </form>
</div>
  <div class="mt-2" *ngIf="application.body.referrals.length > 0 &&  !hasReferralValue ">
    <table class="table table-sm table-hover" style="font-size: 1em">
      <thead class="thead-dark">
      <tr>
        <th scope="col">#</th>
        <th scope="col">{{ "onboarding.referred.onboarding-name" | translate: {Default:"Nombre"} }}</th>
        <th scope="col">{{ "onboarding.referred.onboarding-email" | translate: {Default:"Correo"} }}</th>
        <th scope="col">{{ "onboarding.referred.onboarding-phone" | translate: {Default:"Número de celular"} }}</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let referral of application.body.referrals; let index = index">
        <th scope="row">{{index + 1}}</th>
        <td>{{referral.firstName}} {{referral.additionalNames}} {{referral.lastName}} {{referral.secondLastName}}</td>
        <td *ngIf="referral.email">{{referral.email}}</td>
        <td *ngIf="!referral.email">N/A</td>
        <td *ngIf="referral.phoneNumber">{{referral.phoneNumber}}</td>
        <td *ngIf="!referral.phoneNumber">N/A</td>
        <td>
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn btn-secondary" (click)="application.body.referrals.splice(index, 1)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
<div *ngIf="!hasReferralValue"  class="col-12 mb-3">
    <button class="btn btn-secondary float-left" type="button" (click)="onBack()">{{ "onboarding.referred.back" | translate: {Default:"Regresar"} }}</button>
    <button class="btn btn-primary float-right" type="submit" (click)="onSubmit()">{{ "onboarding.referred.continue" | translate: {Default:"Continuar"} }}</button>
</div>